import React from 'react'
import PropTypes from 'prop-types'
import MedStockBreadcrumb from './MedStockBreadcrumb'
import MedStockDateFilter from './MedStockDateFilter'
import {
  Button,
  Card,
  EmptyState,
  NoDataIcon,
  PageHeader,
} from '@lmc/ui-kit'
import Glyph from '../../../../../../LEGACY/Glyph'
import { EmptyStateDescription } from '@lmc/ui-kit/src/dataDisplay/EmptyState'
import { history } from 'store'

export default function MedStockEmptyState(props) {
  const { item, medication, openStockLogModal, router } = props

  return (
    <div style={styles.wrapper}>
      <PageHeader
        router={router}
        title={`Stock - ${medication.name}`}
        onBack={() => history.back()}
      >
        <Button
          id="add-medication-button"
          onClick={() =>
            openStockLogModal({
              resident: router.params.id,
              medication: router.params.medication_id,
              item: item.id,
              category: item.category,
            })
          }
          style={styles.addMedicationButton}
          variant="primary"
          icon={<Glyph name="plus" />}
        >
          Stock Count
        </Button>
      </PageHeader>
      <br />
      {/* <MedStockBreadcrumb {...props} /> */}
      <MedStockDateFilter {...props} />

      <Card>
        <EmptyState
          icon={<NoDataIcon />}
          title="No stock information for the selected date range"
          description={
            <EmptyStateDescription>
              Learn more about stock counting{' '}
              <a
                href="https://support.logmycare.co.uk/en/articles/5249509-how-does-expected-stock-work"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </EmptyStateDescription>
          }
        ></EmptyState>
      </Card>
    </div>
  )
}

MedStockEmptyState.propTypes = {
  endDate: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  medication: PropTypes.object.isRequired,
  openStockLogModal: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  startDate: PropTypes.object.isRequired,
  todayDate: PropTypes.object.isRequired,
}

const styles = {
  helpLinkContainer: {
    marginTop: 24,
  },
  wrapper: {
    padding: '24px 0px 24px',
    margin: '0px auto',
    maxWidth: 1080,
  },
}
